import { useState } from 'react';

function FavoriteButton({ 
    userId, 
    isFavorite, 
    onToggle, 
    isPending = false, 
    size = 'normal', 
    variant = 'outline',
    disabled = false 
}) {
    const [isHovered, setIsHovered] = useState(false);

    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        if (!disabled && !isPending && onToggle) {
            onToggle(userId);
        }
    };

    const getButtonClass = () => {
        const baseClass = 'base-btn favorite-btn';
        const sizeClass = size === 'icon' ? 'btn-icon' : size === 'small' ? 'btn-sm' : '';
        const variantClass = variant === 'outline' ? 'btn-outline' : variant === 'overlay' ? 'btn-overlay' : '';
        const stateClass = isFavorite ? 'favorited' : '';
        const pendingClass = isPending ? 'pending' : '';
        const disabledClass = disabled ? 'disabled' : '';
        
        return [baseClass, sizeClass, variantClass, stateClass, pendingClass, disabledClass]
            .filter(Boolean)
            .join(' ');
    };

    const getTitle = () => {
        if (isPending) {
            return isFavorite ? 'Removing from favorites...' : 'Adding to favorites...';
        }
        return isFavorite ? 'Remove from favorites' : 'Add to favorites';
    };

    const HeartIcon = ({ filled }) => (
        <svg 
            className="favorite-icon" 
            width={size === 'icon' ? "16" : "14"} 
            height={size === 'icon' ? "16" : "14"} 
            viewBox="0 0 24 24" 
            fill={filled ? "currentColor" : "none"}
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
        </svg>
    );

    const LoadingSpinner = () => (
        <svg 
            className="favorite-loading" 
            width={size === 'icon' ? "16" : "14"} 
            height={size === 'icon' ? "16" : "14"} 
            viewBox="0 0 24 24" 
            fill="none"
        >
            <circle 
                cx="12" 
                cy="12" 
                r="10" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeDasharray="32" 
                strokeDashoffset="32"
            >
                <animate 
                    attributeName="stroke-dasharray" 
                    dur="2s" 
                    values="0 32;16 16;0 32;0 32" 
                    repeatCount="indefinite" 
                />
                <animate 
                    attributeName="stroke-dashoffset" 
                    dur="2s" 
                    values="0;-16;-32;-32" 
                    repeatCount="indefinite" 
                />
            </circle>
        </svg>
    );

    return (
        <button
            className={getButtonClass()}
            onClick={handleClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            title={getTitle()}
            disabled={disabled || isPending}
            aria-label={getTitle()}
        >
            {isPending ? (
                <LoadingSpinner />
            ) : (
                <HeartIcon filled={isFavorite || (isHovered && !isFavorite)} />
            )}
            {size !== 'icon' && (
                <span className="button-text">
                    {isFavorite ? 'Favorited' : 'Favorite'}
                </span>
            )}
        </button>
    );
}

export default FavoriteButton;
